// DownloadsSection

import Container from "../../../components/ui/Container";
import SectionHeader from "../../../components/ui/SectionHeader";
import DownloadItem from "../../../components/ui/DownloadItem";
import { downloadItems } from "../constants/downloadData";

export default function DownloadsSection() {
  return (
    <section id="downloads" className="event-noise bg-twilight-indigo-950 px-0 py-20 text-white md:py-28">
      <Container>
        <div className="mb-14">
          <SectionHeader
            eyebrow="Download"
            title="Elections Results &"
            accent="More"
          />
        </div>

        <div>
          {downloadItems.map((item) => (
            <DownloadItem
              key={item.title}
              title={item.title}
              type={item.type}
              fileUrl={item.fileUrl}
            />
          ))}
        </div>
      </Container>
    </section>
  );
}